import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { GovernyInfo, Spell } from "../../../../lib/types";
import { planSpell, updateSpell } from "../../../../store/actions";
import { DragescentState } from "../../../../store/reducers/stateType";

interface IProps {
  govId?: number;
  spell: Spell;
  target: GovernyInfo;
  cast: {
    id: number;
    tableId: number;
    level: number;
    targetId: number;
  } | undefined;
  disabled: boolean;
}

const SpellCell = ({
  govId,
  spell,
  target,
  cast,
  disabled
}: IProps) => {
  const id = useSelector((state: DragescentState) => state.governorate.id);
  const dispatch = useDispatch();

  return (
    <td
      style={{ width: "100px" }}
      className={`text-center spell-cell ${disabled && !cast ? "disabled" : ""}`}
    >
      <em className="spell-price">{cast ? spell.price : <>&nbsp;</>}</em>
      <div
        style={{ display: "inline-block" }}
        className={`spell ${cast ? "selected" : ""}`}
      >
            <span className="spell-force column">
              <div>&nbsp;</div>
            </span>
        <span className="column">
                <a
                  className="spell-checkbox"
                  onClick={() => (cast || !disabled) && dispatch(planSpell({
                    spellId: spell.id,
                    targetId: target.id,
                    level: 1,
                    spellOn: cast ? 0 : 1,
                    emperorTent: govId ? 1 : 0,
                    sender: govId,
                    isOwner: govId === id
                  }))}
                >
                    <i className="icon icon-zaskrtnuto"/>
                </a>
            </span>
        <span className="column spell-core">
          {(spell.debuff || spell.damage) && !spell.generalSpell && <>
            <a
              className={`spell-switch ${cast && cast.level === 2 ? "active" : ""}`}
              onClick={() => dispatch(updateSpell({
                spellTableId: cast && cast.tableId,
                upType: "level",
                upValue: 2,
                emperorTent: govId ? 1 : 0,
                sender: govId,
                isOwner: govId === id
              }))}
            >
              L 2
            </a>
            <a
              className={`spell-switch ${cast && cast.level === 1 ? "active" : ""}`}
              onClick={() => dispatch(updateSpell({
                spellTableId: cast && cast.tableId,
                upType: "level",
                upValue: 1,
                emperorTent: govId ? 1 : 0,
                sender: govId,
                isOwner: govId === id
              }))}
            >
              L 1
            </a>
          </>}
        </span>
      </div>
    </td>
  )
}

export default SpellCell;
